export const commandType = "SCHEDULE_FLY_TO_YAW";
export const label = "Fly to yaw";
export const isAdminOnly = true;
export const isAdvanced = true;
export const organizations = [];
